<div class="card card-default">
  <div class="card-body">
    <div class="card-header" style="padding-left:0px !important">Question List</div>
    <div class="form-group">
      <div class="form-group row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Type</th>
                  <th>Title</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pageContent of pageContents">
                  <td style="width: 150px;"><img src="{{url}}HelpCenter/{{pageContent.image}}" style="max-width: 100px;" /></td>
                  <td>{{getPageContentType(pageContent.sectionId)}}</td>
                  <td>{{pageContent.title}}</td>
                  <td>
                    <button class="btn btn-xs btn-info" type="button" (click)="edit(pageContent)">Edit</button>&nbsp;
                    <button class="btn btn-xs btn-warning" type="button" (click)="delete(pageContent.id)">Delete</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" style="margin-top: 15px;margin-bottom: 15px">
  <div class="col-md-10">
  </div>
  <div class="col-md-2 text-right">
    <button class="btn btn-info" (click)="newPageContent()">New Page Content</button>
  </div>
</div>
<div>
  <accordion>
    <accordion-group panelClass="b0 mb-2" [isOpen]="isFormOpen">
      <div class="row">
        <div class="col-md-12">
          <input type="file" accept="image/*" (change)="onFileChanged($event)" style="display: none" #fileInput />
          <button class="btn btn-info" (click)="fileInput.click()">Select Image</button>&nbsp;
          <br />
          <progressbar class="progress-striped active" [value]="uploadPercentage" type="danger" *ngIf="uploadPercentage>0&&uploadPercentage<100"><i>{{uploadPercentage}}%</i></progressbar>
        </div>
      </div>
      <br />
      <form [formGroup]="pageContentFormGroup" #mainForm="ngForm" class="form-validate form-horizontal" (submit)="submitForm(mainForm)">
        <div class="form-group row" *ngIf="pageContent.image!=null">
          <div class="col-md-12">
            <img src="{{url}}HelpCenter/{{pageContent.image}}" style="max-width: 100px;" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span class="text-danger" *ngIf="showImageRequired()">Image is required</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Type</label>
          <div class="col-md-9">
            <!--<input class="form-control" type="text" formControlName="type" [(ngModel)]="pageContent.type" />-->
            <select class="form-control" formControlName="sectionId">
              <option [ngValue]="null">Select</option>
              <option value="{{section.id}}" *ngFor="let section of sections">{{section.title}}</option>
              <option value="20">Help Page</option>
            </select>
            <span class="text-danger" *ngIf="pageContentFormGroup.controls['sectionId'].hasError('required') && (pageContentFormGroup.controls['sectionId'].dirty || pageContentFormGroup.controls['sectionId'].touched||mainForm.submitted)">This field is required</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Title</label>
          <div class="col-md-9">
            <input class="form-control" type="text" formControlName="title"/>
            <span class="text-danger" *ngIf="pageContentFormGroup.controls['title'].hasError('required') && (pageContentFormGroup.controls['title'].dirty || pageContentFormGroup.controls['title'].touched||mainForm.submitted)">This field is required</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Search Header</label>
          <div class="col-md-9">
            <input class="form-control" type="text" formControlName="searchHeader"/>
            <span class="text-danger" *ngIf="pageContentFormGroup.controls['searchHeader'].hasError('required') && (pageContentFormGroup.controls['searchHeader'].dirty || pageContentFormGroup.controls['searchHeader'].touched||mainForm.submitted)">This field is required</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Content</label>
          <div class="col-md-9">
            <div [froalaEditor]="options" formControlName="content"></div>
            <span class="text-danger" *ngIf="contentIsNull()">This field is required</span>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Functions</label>
          <div class="col-md-9">
            <app-functions (functionsChanged)="onFunctionsChanged($event)"></app-functions>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-2"></div>
          <div class="col-md-10">
            <button class="btn btn-labeled btn-success mb-2" type="submit">
              <span class="btn-label">
                <i class="fa fa-save"></i>
              </span>Save
            </button>
          </div>
        </div>
      </form>
    </accordion-group>
  </accordion>
</div>
